<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>All Orders</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/orders/new/accounts'><i class="fas fa-plus"></i> New</button>&nbsp;
      <!-- <button class='btn btn-secondary' routerLink='/orders/quick/new/accounts'><i class="fas fa-running"></i> Quick Order</button>&nbsp; -->
      <button class='btn btn-secondary' (click)='simpleOrder()'><i class="fas fa-file-signature"></i> Simplified order</button>
    </div>
  </div>
  <br />
  <br />

  <p><select (change)='changeVehicleType($event)' class='form-control' style='width:10rem;'>
    <option value='-1'>All Vehicle Types</option>
    @for (skill of this.skills; track skill) {
      <option [selected]='this.orderTypeId === skill.orderTypeId' [value]='skill.orderTypeId'>All {{ skill.orderType.name }} Orders</option>
    }
  </select></p>


  <br />
  <br />
  <div class='sheet' style='padding: 0.1rem;font-size: 0.65rem;'>
    <h3>Filters</h3>
    <div class='row'>
      <div class='col-md-4'>
        <label>Order ID</label>
        <input [(ngModel)]="this.searchFilters.orderId" class='form-control' type='text' />
      </div>
      <div class='col-md-4'>
        <label>Customer</label>
        <ng-select [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
          @for (item of this.accounts; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Tip Site</label>
        <ng-select [(ngModel)]="this.searchFilters.tipSite" (change)='this.searchFilters.tipSite = $event;'>
          @for (item of this.tips; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Date</label>
        <input [(ngModel)]="this.searchFilters.date" class='form-control' type='date' />
      </div>
      <div class='col-md-4'>
        <label>Po Number</label>
        <input [(ngModel)]="this.searchFilters.poNumber" class='form-control' type='text' />
      </div>
      <div class='col-md-4'>
        <label>Status</label>
        <ng-select [(ngModel)]="this.searchFilters.status" (change)='this.searchFilters.status = +$event;'>
          @for (item of this.statuses; track item) {
            <ng-option [value]='item.id'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' type='button' (click)='search()'>Search</button>&nbsp;
    <button class='btn btn-danger' type='button' (click)='clear()'>Clear</button>
  </div>

  <br />
  <br />

  <!-- <div>
  <button class='btn blueHover' (click)='this.setOrderStatus("")' [class.btn-primary]='this.orderStatusCurrent === ""' [class.btn-secondary]='this.orderStatusCurrent !== ""'><i class="fas fa-truck-loading"></i> All Orders</button>&nbsp;
  <button class='btn purpleHover' (click)='this.setOrderStatus("Pending")'  [class.btn-info]='this.orderStatusCurrent === "Pending"' [class.btn-secondary]='this.orderStatusCurrent !== "Pending"'><i class="fas fa-question-circle"></i> Pending</button>&nbsp;
  <button class='btn greenHover' (click)='this.setOrderStatus("Accepted")'  [class.btn-success]='this.orderStatusCurrent === "Accepted"' [class.btn-secondary]='this.orderStatusCurrent !== "Accepted"'><i class="fas fa-check-circle"></i> Accepted</button>&nbsp;
  <button class='btn redHover' (click)='this.setOrderStatus("Declined")'  [class.btn-danger]='this.orderStatusCurrent === "Declined"' [class.btn-secondary]='this.orderStatusCurrent !== "Declined"'><i class="fas fa-times-circle"></i> Declined</button>&nbsp;
</div> -->
<br />
<app-grid
  entity='order'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFiltersGrid'
  [searchFields]='this.searchFields'
  [relationships]='this.relationships'
></app-grid>
